"use client";

import { createContext, ReactNode } from 'react';

export const LocaleContext = createContext<string>('pl');

interface LocaleProviderProps {
  locale: string;
  children: ReactNode;
}

export const LocaleProvider = ({ locale, children }: LocaleProviderProps) => (
  <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>
);
